<cmps-wait-status
    [srStatus]="'Loading ' + config.title"
    *ngIf="hasPendingData"
></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<div
    class="container-fluid cmps-widget-dual-chart-performance-comparison"
    *ngIf="!hasPendingData && dateRanges != null"
>
    <div class="row">
        <!--TODO revise tl-->
        <div
            class="mb-2"
            style="padding-top: 13px"
        >
            <span class="sr-only">Date Range: </span
            >{{ dateRange[0] | date: 'y-MM-dd' }} -
            {{ dateRange[1] | date: 'y-MM-dd' }}
        </div>
        <div class="ml-auto col-7 col-md-7 col-lg-7 text-right mb-7">
            <div class="row">
                <label
                    for="mbnaDateRange"
                    style="padding-top: 13px"
                    >{{ i18n._709_DATE_RANGE | translate }}</label
                >
                <select
                    class="custom-select ml-auto col-7 col-md-7 col-lg-7 mb-7"
                    id="mbnaDateRange"
                    [ngModel]="selectedDateRange"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="updateWidget($event)"
                >
                    <option
                        *ngFor="let i of dateRanges; let ii = index"
                        [value]="ii"
                    >
                        {{ i.label }}
                    </option>
                </select>
            </div>
        </div>
    </div>
    <div
        class="row"
        *ngIf="data != null"
    >
        <div
            class="col-12 col-sm-{{ 12 / data.length }} dcpc-pie-bar"
            *ngFor="let i of data"
        >
            <cmps-widget-pie-bar
                [data]="i"
                [hasPieBarClick]="true"
                (pieBarClick)="onPieBarClick($event)"
            >
            </cmps-widget-pie-bar>
        </div>
    </div>
</div>
